/** YYYY-MM-DD in the user's local timezone (for `<input type="date">`). */
export function formatLocalInputDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function todayInputDate(): string {
  return formatLocalInputDate(new Date());
}

export function getDefaultWalletDateRange(): {
  startDate: string;
  endDate: string;
} {
  const start = new Date();
  start.setFullYear(start.getFullYear() - 1);
  return {
    startDate: formatLocalInputDate(start),
    endDate: todayInputDate(),
  };
}

export function applyWalletDateRangeChange(
  prev: { startDate: string; endDate: string },
  field: "startDate" | "endDate",
  rawValue: string,
  clampToToday = true,
): { startDate: string; endDate: string } {
  const today = todayInputDate();
  const value =
    clampToToday && rawValue && rawValue > today ? today : rawValue;

  if (field === "startDate") {
    const startDate = value;
    let endDate = prev.endDate;
    if (startDate && endDate && startDate > endDate) {
      endDate = startDate;
    }
    if (clampToToday && endDate > today) {
      endDate = today;
    }
    return { startDate, endDate };
  }

  const endDate = value;
  let startDate = prev.startDate;
  if (endDate && startDate && endDate < startDate) {
    startDate = endDate;
  }
  return { startDate, endDate };
}
